import React from 'react';
import {Button as AntButton} from 'antd';
import './styles.less';
const Button = (props) => {
    return (
            <AntButton {...props} className={`hms-button ${props.className}`}>{props.children}</AntButton>
    )
}
export default Button;
export const ButtonGroup = AntButton.Group;